import React from "react";
import NavBar from "../components/layout/protected/NavBar";
import RequireAuth from "./RequireAuth";
import RequirePermission from "./RequirePermission";
import { Navigate, useLocation } from "react-router-dom";
import getSessionCookie from "../utils/getSessionCookie";

type Props =
  | {
      title: string;
      path: string;
      Layout: (props: { children: JSX.Element }) => JSX.Element;
      Component: (props: any) => JSX.Element;
      isAuthProtected: boolean;
      module: string;
    }
  | {
      title: string;
      path: string;
      Layout: (props: { children: JSX.Element }) => JSX.Element;
      Component: (props: any) => JSX.Element;
      isAuthProtected: boolean;
      module?: undefined;
    };

function AppRoute({
  Component,
  Layout,
  isAuthProtected,
  module,
  title,
  path,
}: Props) {
  document.title = `${title} | RNR ROOMS B2B`;

  const location = useLocation();

  if (path === "/") {
    const auth_token = getSessionCookie("token");

    if (auth_token) {
      return <Navigate to="/dashboard" state={{ from: location }} replace />;
    }
  }

  if (isAuthProtected) {
    return (
      <RequireAuth>
        <RequirePermission module={module!}>
          <Layout>
            <>
              <NavBar />
              <Component />
            </>
          </Layout>
        </RequirePermission>
      </RequireAuth>
    );
  } else {
    return (
      <Layout>
        <>
          <Component />
        </>
      </Layout>
    );
  }
}
export default AppRoute;
